import React from "react";

const PrivacySection = ({ title, children }) => (
  <div className="privacy-section">
    <h2 className="tw-text-xl">{title}</h2>
    <p className="tw-mb-6">{children}</p>
  </div>
);

const PrivacyPolicy = () => {
  return (
    <>
      <div className="privacy-policy">
        <h1 className="tw-text-2xl tw-font-bold tw-mb-4">Privacy Policy</h1>

        <PrivacySection title="1. Introduction">
          Welcome to We are uniters, where your well-being is our top priority.
          At We are uniters, we provide you with high-quality wellness products
          and services that support a healthier and more vibrant lifestyle. We
          understand the importance of your privacy and are committed to
          protecting the personal information you share with us. This Privacy
          Policy outlines how we collect, use, and safeguard your data to ensure
          that you can shop with conﬁdence and peace of mind. We encourage you
          to read this policy carefully to understand how we handle your
          information, your rights concerning your data, and how to contact us
          with any privacy-related inquiries. By using our products and
          services, you are agreeing to the terms outlined in this policy. Your
          trust is essential to us, and we take our responsibility to protect
          your privacy seriously.
        </PrivacySection>

        <PrivacySection title="2. Information We Collect">
          At We are uniters, we collect various types of information to provide
          you with our wellness products and services. The information we
          collect may include, but is not limited to:
          <ul>
            <li>
              <strong>Personal Information:</strong> This includes your name,
              date of birth, gender, and other identifying information necessary
              for order processing and creating a personalized shopping
              experience.
            </li>
            <li>
              <strong>Contact Details:</strong> We collect your contact
              information, such as your email address, mailing address, and
              phone number, to facilitate communication, send order updates, and
              deliver products to your preferred location.
            </li>
            <li>
              <strong>Payment Information:</strong> To complete transactions, we
              collect payment details, including credit card numbers or other
              payment methods. We utilize secure payment processors to handle
              payment transactions.
            </li>
            <li>
              <strong>Account Information:</strong> If you create an account
              with us, we collect information related to your account, such as
              your username, password, and account preferences.
            </li>
            <li>
              <strong>Product Preferences:</strong> We may collect information
              about your wellness product preferences to tailor product
              recommendations and improve your overall shopping experience.
            </li>
            <li>
              <strong>Communication Data:</strong> Information related to your
              interactions with our customer support, feedback, and surveys may
              be collected to improve our services and address your inquiries.
            </li>
          </ul>
        </PrivacySection>

        <PrivacySection title="3. How We Use Your Information">
          At We are uniters, we collect and use customer data for several
          essential purposes that enable us to provide you with exceptional
          wellness products and services. These purposes include but are not
          limited to:
          <ul>
            <li>
              <strong>Order Processing:</strong> We collect and use your
              personal information, contact details, and payment information to
              process your orders efficiently.
            </li>
            <li>
              <strong>Communication:</strong> We use your contact information to
              send you order confirmations, shipping updates, and important
              notifications related to your account or our services.
            </li>
            <li>
              <strong>Customer Support:</strong> We may use your information to
              address your requests and provide the assistance you require.
            </li>
            <li>
              <strong>Marketing and Promotions:</strong> With your consent, we
              may use your data to send you marketing materials, special offers,
              promotions, and product recommendations.
            </li>
            <li>
              <strong>Account Management:</strong> We use your account
              information to manage and secure your account.
            </li>
            <li>
              <strong>Product and Service Improvements:</strong> We may analyze
              customer data to enhance our product offerings, website
              functionality, and overall customer experience.
            </li>
            <li>
              <strong>Legal Obligations:</strong> We may be required by law to
              collect and use customer data for legal purposes, such as
              complying with tax regulations or responding to lawful government
              requests.
            </li>
            <li>
              <strong>Research and Analysis:</strong> We may conduct research
              and analysis using aggregated and anonymized data to better
              understand customer needs and market trends.
            </li>
          </ul>
        </PrivacySection>

        <PrivacySection title="4. Data Sharing">
          At We are uniters, we take your privacy seriously. We may share
          customer data with third parties in the following cases:
          <ul>
            <li>
              <strong>Business Partners and Affiliates:</strong> We may share
              customer data with trusted business partners who help us deliver
              our wellness products and services.
            </li>
            <li>
              <strong>Service Providers:</strong> We may share data with
              third-party service providers, such as shipping companies and
              payment processors.
            </li>
            <li>
              <strong>Legal Obligations and Compliance:</strong> In some cases,
              we may be required to share customer data with government
              authorities or regulatory agencies.
            </li>
            <li>
              <strong>No Sale of Customer Data:</strong> We do not sell customer
              data under any circumstances.
            </li>
          </ul>
        </PrivacySection>

        <PrivacySection title="5. Security Measures">
          At We are uniters, we employ several security measures to protect your
          personal information. These measures include encryption, access
          controls, data breach procedures, and regular security audits.
        </PrivacySection>

        <PrivacySection title="6. Your Choices">
          You have control over your personal data. You can access, correct, and
          delete your data as per the applicable regulations.
        </PrivacySection>
      </div>
      <div className="tw-text-right rtl:text-right tw-text-lg" dir="rtl">
        <p>
          <strong className="tw-block  tw-my-2">شروط الاستخدام</strong>
        </p>
        <p>
          <strong className="tw-block  tw-my-2">1. قبول الشروط:</strong> مرحبًا
          بكم في We are uniters! باستخدام موقعنا، منتجاتنا، وخدماتنا، فإنك توافق
          على الالتزام بهذه الشروط. إذا كنت لا توافق على أي جزء من هذه الشروط،
          يرجى الامتناع عن استخدام موقعنا وخدماتنا.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">2. سلوك المستخدم:</strong> عند
          استخدام We are uniters، توافق على عدم:
        </p>
        <ul>
          <li>
            الانخراط في أي نشاط قد يلحق الضرر أو يعطل أو يتداخل مع موقعنا أو
            خدماتنا.
          </li>
          <li>استخدام موقعنا وخدماتنا لأغراض غير قانونية أو غير مصرح بها.</li>
          <li>انتهاك أي قوانين أو لوائح أو حقوق طرف ثالث.</li>
        </ul>

        <p>
          <strong className="tw-block  tw-my-2">3. الملكية الفكرية:</strong>{" "}
          جميع المحتويات على موقعنا وخدماتنا، بما في ذلك النصوص والصور والشعارات
          والبرمجيات، محمية بقوانين الملكية الفكرية. لا يجوز لك استخدام أو توزيع
          هذه المحتويات بدون موافقتنا الكتابية الصريحة.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">
            4. الخصوصية وجمع البيانات:
          </strong>{" "}
          استخدامك لـ We are uniters يخضع لسياسة الخصوصية الخاصة بنا. يرجى
          مراجعة سياسة الخصوصية الخاصة بنا لفهم كيفية جمعنا واستخدامنا وحماية
          بياناتك.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">5. الإنهاء:</strong> نحتفظ بالحق
          في إنهاء أو تعليق وصولك إلى موقعنا أو خدماتنا حسب تقديرنا، دون إشعار،
          لانتهاك هذه الشروط.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">
            6. الروابط إلى مواقع الطرف الثالث:
          </strong>{" "}
          قد يحتوي We are uniters على روابط لمواقع الطرف الثالث. يتم توفير هذه
          الروابط لراحتك، لكننا لا نصادق أو نتحكم في المحتوى على هذه المواقع.
          نحن غير مسؤولين عن أي مشاكل أو أضرار قد تنشأ عن استخدامك لمواقع الطرف
          الثالث.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">7. تحديد المسؤولية:</strong> We
          are uniters غير مسؤولة عن أي أضرار أو خسائر تنتج عن استخدامك لموقعنا
          أو خدماتنا. استخدامك لموقعنا هو على مسؤوليتك الخاصة.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">
            8. التغييرات في شروط الاستخدام:
          </strong>{" "}
          قد نقوم بتحديث هذه الشروط من وقت لآخر. سيتم نشر أي تغييرات على موقعنا،
          ومن مسؤوليتك مراجعتها بشكل دوري. الاستمرار في استخدام موقعنا بعد إجراء
          التغييرات يعني قبولك للشروط المعدلة.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">9. القانون الحاكم:</strong> تخضع
          هذه الشروط لقوانين [إدراج الولاية القضائية] دون اعتبار لتضارب أحكام
          القانون.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">10. معلومات الاتصال:</strong>{" "}
          إذا كانت لديك أي أسئلة أو مخاوف بشأن هذه الشروط، يرجى الاتصال بنا
          باستخدام المعلومات المقدمة في قسم "معلومات الاتصال" في سياسة الخصوصية.
          تم تحديث هذه الشروط في 11 أكتوبر 2023. شكرًا لاختيارك We are uniters،
          ونحن نقدر امتثالك لهذه الشروط.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">
            سياسة الخصوصية لـ We are uniters
          </strong>
        </p>

        <p>
          <strong className="tw-block  tw-my-2">1. المقدمة:</strong> مرحبًا بكم
          في We are uniters، حيث نعتبر رفاهيتكم أولويتنا القصوى. في We are
          uniters، نقدم لكم منتجات وخدمات عالية الجودة تدعم أسلوب حياة أكثر صحة
          ونشاطًا. نحن نفهم أهمية خصوصيتكم ونلتزم بحماية المعلومات الشخصية التي
          تشاركونها معنا. توضح سياسة الخصوصية هذه كيفية جمعنا واستخدامنا
          وحمايتنا لبياناتكم لضمان أنكم تتسوقون بثقة وراحة بال. نحثكم على قراءة
          هذه السياسة بعناية لفهم كيفية تعاملنا مع معلوماتكم، حقوقكم المتعلقة
          ببياناتكم، وكيفية الاتصال بنا لأي استفسارات تتعلق بالخصوصية. باستخدام
          منتجاتنا وخدماتنا، فإنكم توافقون على الشروط الموضحة في هذه السياسة.
        </p>

        <p>
          <strong className="tw-block  tw-my-2">
            2. المعلومات التي نجمعها:
          </strong>{" "}
          في We are uniters، نجمع أنواعًا مختلفة من المعلومات لتقديم منتجاتنا
          وخدماتنا الصحية لكم. قد تشمل المعلومات التي نجمعها، على سبيل المثال لا
          الحصر:
        </p>
        <ul>
          <li>
            المعلومات الشخصية: يشمل ذلك اسمكم، تاريخ ميلادكم، جنسكم، وغيرها من
            المعلومات التعريفية الضرورية لمعالجة الطلبات وإنشاء تجربة تسوق
            مخصصة.
          </li>
          <li>
            تفاصيل الاتصال: نجمع معلومات الاتصال الخاصة بكم، مثل عنوان البريد
            الإلكتروني، العنوان البريدي، ورقم الهاتف، لتسهيل التواصل، إرسال
            تحديثات الطلبات، وتسليم المنتجات إلى الموقع المفضل لديكم.
          </li>
          <li>
            معلومات الدفع: لإتمام المعاملات، نجمع تفاصيل الدفع بما في ذلك أرقام
            بطاقات الائتمان أو طرق الدفع الأخرى. من المهم ملاحظة أننا لا نخزن
            معلومات الدفع على خوادمنا. نحن نستخدم معالجات دفع آمنة للتعامل مع
            المعاملات.
          </li>
          <li>
            معلومات الحساب: إذا قمتم بإنشاء حساب معنا، نجمع معلومات تتعلق
            بحسابكم مثل اسم المستخدم، كلمة المرور، وتفضيلات الحساب.
          </li>
          <li>
            تفضيلات المنتجات: قد نجمع معلومات حول تفضيلاتكم في المنتجات الصحية
            لتخصيص توصيات المنتجات وتحسين تجربة التسوق الشاملة.
          </li>
          <li>
            بيانات التواصل: قد يتم جمع معلومات تتعلق بتفاعلاتكم مع دعم العملاء
            لدينا، التغذية الراجعة، والاستطلاعات لتحسين خدماتنا ومعالجة
            استفساراتكم.
          </li>
        </ul>

        <p>
          <strong className="tw-block  tw-my-2">مصادر جمع البيانات:</strong> نحن
          نجمع البيانات بشكل أساسي مباشرة من العملاء عندما تقومون بإجراء شراء،
          إنشاء حساب، أو التفاعل مع موقعنا وخدماتنا. في بعض الحالات، قد نحصل على
          المعلومات من خلال المصادر التالية:
        </p>
        <ul>
          <li>
            الأطراف الثالثة: قد نتلقى معلومات من شركاء وأطراف ثالثة، مثل
            الموزعين أو شركاء التسويق، الذين يساعدون في الترويج لمنتجاتنا
            وخدماتنا.
          </li>
          <li>
            الكوكيز وتقنيات التتبع: عندما تزورون موقعنا، قد نستخدم الكوكيز
            وتقنيات التتبع المماثلة لجمع معلومات حول أنشطتكم عبر الإنترنت.
          </li>
          <li>
            المعلومات المتاحة للعامة: قد نجمع المعلومات المتاحة للعامة من مصادر
            موثوقة لتعزيز فهمنا لتفضيلات العملاء والاتجاهات.
          </li>
        </ul>

        <p>
          <strong className="tw-block tw-my-2">
            3. كيفية استخدامنا لمعلوماتكم:
          </strong>{" "}
          في We are uniters، نجمع ونستخدم بيانات العملاء لأغراض عديدة أساسية
          تمكننا من تزويدكم بمنتجات وخدمات صحية استثنائية. تشمل هذه الأغراض:
        </p>
        <ul>
          <li>معالجة الطلبات.</li>
          <li>التواصل.</li>
          <li>دعم العملاء.</li>
          <li>التسويق والعروض الترويجية.</li>
          <li>إدارة الحساب.</li>
          <li>تحسين المنتجات والخدمات.</li>
          <li>الالتزامات القانونية.</li>
          <li>البحث والتحليل.</li>
        </ul>
      </div>
    </>
  );
};

export default PrivacyPolicy;
